import React, { useEffect, useState } from "react";
import {
  getOrderSummaryAPI,
  OrderSummaryResponse,
} from "../../Utils/CheckoutAPIs/CheckoutAPIs";

interface SummaryModalBodyProps {
  sections: Array<{ title: string; subTitle: React.ReactNode }>;

  orderID: string;
}

const PaymentSuccessfulSummary: React.FC<SummaryModalBodyProps> = ({
  sections,
  orderID,
}) => {
  const [summaryResponse, setSummaryResponse] =
    useState<OrderSummaryResponse>();
  useEffect(() => {
    getOrderSummaryAPI(orderID)
      .then((response) => {
        setSummaryResponse(response);
      })
      .catch((error) => {
        console.log("Error fetching order summary", error);
      });
  }, [orderID]);

  const itemIds = sessionStorage.getItem("item_ids");

  return (
    <div className="summary-modal-body">
      <div className="summary-row">
        <div style={{ textAlign: "left" }} className="summary-grid">
          {sections.map((section, index) => (
            <div
              style={{
                backgroundColor: "rgba(44, 106, 177, 0.1)",
                padding: "20px",
                borderRadius: "8px",
                boxShadow: "0px 0px 10px 0px rgba(0, 0, 0, 0.01)",
              }}
              key={index}
            >
              <div className="summary-title">{section.title}</div>
              <br />
              <div className="summary-subtitle">{section.subTitle}</div>
            </div>
          ))}
        </div>
        {summaryResponse && (
          <div
            style={{
              textAlign: "left",

              padding: "30px 20px 20px 20px",

              maxWidth: "300px",
            }}
          >
            <div className="summary-title">Order Summary</div>
            <br />
            <div className="summary-subtitle">
              <strong> Payment Method:</strong>{" "}
              {summaryResponse.data.paymentMethod.includes("upi")
                ? "UPI"
                : summaryResponse.data.paymentMethod}
            </div>
            <br />
            <div className="summary-subtitle">
              <strong>Order ID:</strong> {summaryResponse.data.orderID}
            </div>
            <br />
            <div className="summary-subtitle">
              <strong>Order Details:</strong>
              {summaryResponse.data.orderItems.split(",").map((item) => (
                <li
                  style={{ color: "rgba(44, 106, 177, 1)", margin: "5px 0px" }}
                  key={item}
                >
                  {item}
                </li>
              ))}
            </div>
            <br />
            <div className="summary-subtitle">
              {summaryResponse.data.paymentType === "cod" ? (
                <strong>Amount to be Paid: </strong>
              ) : (
                <strong>Amount Paid: </strong>
              )}
              ₹ {summaryResponse.data.amountPaid}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default PaymentSuccessfulSummary;
